<template>
    <div class="productInner">
        <span
            v-for="(item,index) in handlerProduct()"
            :key="index"
            class="inner-content"
            v-if="index <= 2 "
        >{{item}}({{getCode(strList,index)}})</span>
<!--        超过行显示...-->
<!--       scope.row.authorizedProducts -->
        <span v-if="handlerProduct().length > count">...</span>
    </div>
</template>

<script>
export default {
    name: "productInner",
    props: {
        productList: {
            type: Array,
            default(){
                return [];
            }
        },
        strList:{
            //scope.row.authorizedProducts
            type: String,
        }
    },
    data() {
        return {
            count: 4
        }
    },
    methods: {
        handlerProduct(){
            let handlerArr = this.strList.split(',');
            let textArr = [];
            for (let i = 0; i < this.productList.length; i++) {
                if(handlerArr.indexOf(this.productList[i].productCode) > - 1){
                    textArr.push(this.productList[i].productName);
                }
            }
            return textArr;
        },
        getCode(authorizedProducts,index){
            let arr = authorizedProducts.split(',');
            return arr[index];
        },
    },
}
</script>

<style lang="scss" scoped>
.productInner {
    .inner-content {
        display: block;
    }
}
</style>